import script from "./PartnersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnersView.vue?vue&type=script&lang=ts&setup=true"

import "./PartnersView.vue?vue&type=style&index=0&id=2ebbf667&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebbf667"]])

export default __exports__